import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { PaymentInformation } from '.';
import { redirectToFAQ, redirectToLink } from '../helpers/util';
import { Details, FlexStart, Link, LinkGray, SpaceBetween, Title, Divider } from './styled';

const mapStateToProps = (state: any) => ({
  language: state.appData.language,
  general: state.appData.general,
});
type Props = ReturnType<typeof mapStateToProps>;

class CardInfo extends React.Component<Props> {
  render() {
    return (
      <Details>
        <SpaceBetween>
          <Title>
            <FormattedMessage id="payment_information" />
          </Title>
        </SpaceBetween>
        <PaymentInformation update={true} />
        <Divider />
        <Link onClick={() => redirectToFAQ(this.props.language)}>
          <FormattedMessage id="payment_faq" />
        </Link>
        <FlexStart>
          <LinkGray onClick={() => redirectToLink(this.props.general.config.termsOfUseLink, this.props.language)}>
            <FormattedMessage id="terms_of_use" />
          </LinkGray>
          &nbsp; | &nbsp;
          <LinkGray onClick={() => redirectToLink(this.props.general.config.privacyPolicyLink, this.props.language)}>
            <FormattedMessage id="privacy_policy" />
          </LinkGray>
        </FlexStart>
      </Details>
    );
  }
}

export default connect<Props>(mapStateToProps)(CardInfo);
